import type { BoxAnswer } from "../../../../types/dashboard";
import eyeCrossedUrl from "../../../../assets/icons/eye-crossed.png";
import eyeUrl from "../../../../assets/icons/eye.png";
import downloadedIconUrl from "../../../../assets/icons/downloaded-icon.png";
import { StyledResponsesList } from "./ResponsesList.styled";
type ResponsesListProps = {
  items: BoxAnswer[];
  onSelect: (answer: BoxAnswer) => void;
  onToggleStatus: (answer: BoxAnswer) => void;
  updatingId?: string | null;
};

const ResponsesList = ({
  items,
  onSelect,
  onToggleStatus,
  updatingId,
}: ResponsesListProps) => (
  <StyledResponsesList>
    {items.map((a) => (
      <button
        key={a.id}
        type="button"
        className="response-card"
        onClick={() => void onSelect(a)}
      >
        <span
          className="response-card-icon"
          onClick={(e) => {
            e.stopPropagation();
            onToggleStatus(a);
          }}
          role="button"
          tabIndex={0}
          aria-label={a.status === "pending" ? "סמן כנקרא" : "סמן כלא נקרא"}
          style={{ cursor: updatingId === a.id ? "not-allowed" : "pointer" }}
        >
          {a.status === "pending" ? (
            <img
              src={eyeCrossedUrl}
              alt=""
              className={`response-card-icon-img ${updatingId === a.id ? "loading" : ""}`}
              width={22}
              height={22}
            />
          ) : a.status === "answered" ? (
            <img
              src={downloadedIconUrl}
              alt=""
              className={`response-card-icon-img ${updatingId === a.id ? "loading" : ""}`}
              width={22}
              height={22}
            />
          ) : (
            <img
              src={eyeUrl}
              alt=""
              className={`response-card-icon-img ${updatingId === a.id ? "loading" : ""}`}
              width={22}
              height={22}
            />
          )}
        </span>
        <p className="response-card-text">{a.question_text}</p>
      </button>
    ))}
  </StyledResponsesList>
);

export default ResponsesList;
